<template>
  <div>
    <loading :active.sync="isLoading" color="#85344c"></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/uniodonto/planos">Planos</router-link>
          </li>
          <li class="breadcrumb-item active">Detalhes plano {{plano.name}}</li>
        </ol>

        <div class="row">
          <div class="col-md-12" v-if="mostraErro">
            <div class="alert alert-danger alert-dismissible" role="alert">
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <strong>Ops!</strong>
              <span>{{erroMensagem}}</span>
            </div>
          </div>
        </div>

        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-info-circle"></i>Informações do Plano
            </h2>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Nome <b>*Obrigatório</b></label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Informe o nome do plano"
                  v-model="plano.name"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Código ANS <b>*Obrigatório</b></label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Informe o código ANS"
                  v-model="plano.ans"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Foto do plano</label>
                <input
                  type="file"
                  class="form-control"
                  placeholder="Informe a foto"
                  @change="trocaFoto"
                />
              </div>
              <img :src="imagem_foto" class="img-thumbnail" />
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label>Pessoa</label>
                <select class="form-control" @change="e => plano.tipo_plano = e.target.value" v-model="plano.tipo_plano">
                  <option value="0">Pessoa física</option>
                  <option value="1">Pessoa jurídica</option>
                  <option value="2">Plano Familiar</option>
                </select>
              </div>
            </div>

            <div class="col-12" v-if="plano.planos_vinculados && plano.planos_vinculados.length == 0">
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Preço</label>
                    <money v-model="plano.price" v-bind="money" type="text" class="form-control"></money>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Taxa adesão</label>
                    <money v-model="plano.setup_fee" v-bind="money" type="text" class="form-control"></money>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Uniodonto</label>
                    <select
                      id="inputUniodonto"
                      v-model="plano.provider_id"
                      class="form-control"
                    >
                      <option
                        v-for="(operadora,index) in operadoras"
                        :key="index"
                        :value="operadora.id"
                      >{{operadora.name}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Status do plano</label>
                    <select class="form-control" v-model="plano.active">
                      <option :value="1">Ativo</option>
                      <option :value="0">Desativado</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Periodo de recorrência</label>
                    <select
                      class="form-control"
                      v-model="plano.unit_interval"
                    >
                      <option value="Monthly" selected>Mensal</option>
                      <option value="Bimonthly">Bimensal</option>
                      <option value="Quarterly">Trimestral</option>
                      <option value="SemiAnnual">Semestral</option>
                      <option value="Annual">Anual</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="form-group">
                    <label>Dias de Carência no Cartão de Crédito</label>
                    <input
                      type="number"
                      class="form-control"
                      placeholder="Informe os dias de carência desse plano"
                      v-model="plano.carencia"
                    >
                  </div>
                </div>
              </div>
            </div>
            <div div class="row col-md-12" v-for="(plan, index) in faixas" :key="index" v-else-if="Number(plano.tipo_plano) === 1">
            <div class="col-md-12 mt-4 mb-4 text-center">
              <h4>Faixa {{ index + 1 }}</h4>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Preço <b>*Obrigatório</b></label>
                <money v-model="plan.price" v-bind="money" type="text" class="form-control"></money>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Dias de Carência no Cartão de Crédito</label>
                <input v-model="plan.carencia" class="form-control" type="number"
                  placeholder="Informe o dia de carência. Ex: 10" />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Taxa adesão</label>
                <money v-model="plan.setup_fee" v-bind="money" type="text" class="form-control"></money>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Preço por Boleto</label>
                <money v-model="plan.valor_boleto" v-bind="money" type="text" class="form-control">
                </money>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Dias de Carência no Boleto</label>
                <input v-model="plan.carencia_boleto" type="number" class="form-control"
                  placeholder="Informe o dia de carência. Ex: 10" />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Qtd Participantes Min <b>*Obrigatório</b></label>
                <input type="number" class="form-control" placeholder="Min" v-model="plan.min">
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Qtd Participantes Max <b>*Obrigatório</b></label>
                <input type="number" class="form-control" placeholder="Max" v-model="plan.max">
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Status da Faixa</label>
                <select class="form-control" @change="e => plan.active = e.target.value" v-model="plan.active">
                  <option value="1">Ativo</option>
                  <option value="0">Desativado</option>
                </select>
              </div>
            </div>

            <div class="col-md-1 text-center text-md-left mb-3 mb-md-0 align-self-center mt-3">
              <div class="">

                <button v-if="index === faixas.length - 1" class="" @click="handleClickAddPlan">
                  <i class="fa fa-plus" style="font-size: 22px;"></i>
                </button>

                <button v-else class="" @click="handleClickRemovePlan(index)">
                  <i class="fa fa-minus" style="font-size: 22px;"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="col-12" v-else-if="Number(plano.tipo_plano) === 2">
            <div
              class="row"
              v-for="(plan, index) in plano.planos_vinculados"
              :key="index"
            >
              <div class="col-md-12 mt-4 mb-4 text-center">
                <h4>Plano Vinculado {{ index + 1 }}</h4>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label>Plano Base</label>
                  <select v-model="plan.plans_id" class="form-control" @change="getValoresDoPlano(plan)">
                    <option
                      v-for="pl in listaPlanos"
                      :key="pl.id"
                      :value="pl.id"
                    >
                      {{ pl.name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label>Preço</label>
                  <money v-model="plan.price" v-bind="money" class="form-control"></money>
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label>Taxa adesão</label>
                  <money v-model="plan.setup_fee" v-bind="money" class="form-control"></money>
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label>Carência (Crédito)</label>
                  <input v-model="plan.carencia" type="number" class="form-control" />
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-group">
                  <label>Qtd. Miníma</label>
                  <input v-model="plan.qtd_min" type="number" class="form-control" />
                </div>
              </div>

              <div class="col-md-1 d-flex align-items-center mt-3">
                <button class="btn" @click="removePlanoVinculado(index)">
                  <i class="fa fa-minus"></i>
                </button>
              </div>
            </div>
            <div class="col-md-12 text-center mt-4">
              <button class="btn " @click="addPlanoVinculado">
                <i class="fa fa-plus"></i> Adicionar Plano Vinculado
              </button>
            </div>
          </div>

          <div class="col-md-4">
              <div class="form-group">
                <label>Dias de Carência no Boleto</label>
                <input
                  type="number"
                  class="form-control"
                  placeholder="Informe os dias de carência desse plano"
                  v-model="plano.carencia_boleto"
                >
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>Quantidade Pessoas por Plano</label>
                <input v-model="plano.qtd_membros" type="number" class="form-control" placeholder="Informe a quantidade de pessoas por plano. Ex: 6"/>
              </div>
            </div>

            <!-- CAMPO ADICIONADO -->
            <div class="col-md-4">
              <div class="form-group">
                <label>Quantidade Máxima de Pessoas por Plano</label>
                <input v-model="plano.qtd_max_membros" type="number" class="form-control" placeholder="Informe a quantidade máxima de pessoas por plano. Ex: 6"/>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>Preço por boleto</label>
                <money v-model="plano.valor_boleto" v-bind="money" type="text" class="form-control"></money>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Número do Plano</label>
                <input v-model="plano.plan_number" type="text" class="form-control"></input>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Contrato</label>
                <input v-model="plano.contrato" type="text" class="form-control"></input>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Token Acesso</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Informe o token"
                  v-model="plano.TokenAcesso"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Recorrente</label>
                <select v-model="plano.recorrencia" class="form-control">
                  <option :value="1">Sim</option>
                  <option :value="0">Não</option>
                </select>
              </div>
            </div>

            
          <div class="col-md-12">
            <label>Atribuir desconto:</label>
            <div class="col-md-2">
              <div class="form-check d-flex flex-column">
                <input class="form-check-input" @change="plano.tipo_desconto='porcentagem'"  type="radio" name="exampleRadios" id="exampleRadios1" value="option1" :checked="plano.tipo_desconto=='porcentagem'">
                <label class="form-check-label" for="exampleRadios1">
                  Porcentagem
                </label>
              </div>
              <div class="form-check">
                <input class="form-check-input" @change="plano.tipo_desconto='abs'" type="radio" name="exampleRadios" :checked="plano.tipo_desconto=='abs'" id="exampleRadios2" value="option2">
                <label class="form-check-label" for="exampleRadios2">
                  Valor Absoluto
                </label>
              </div>
              <div class="form-check">
                <input class="form-check-input" @change="plano.tipo_desconto = null; plano.valor_desconto = 0;" type="radio" name="exampleRadios" :checked="plano.tipo_desconto == null" id="exampleRadios3" value="option3">
                <label class="form-check-label" for="exampleRadios3">
                  Nenhum
                </label>
              </div>
            </div>
            <div class="col-md-4">
              <div v-if="plano.tipo_desconto == 'porcentagem'" class="form-group">
                <label>Porcentagem</label>
                <input
                  type="number"
                  class="form-control"
                  placeholder
                  v-model="plano.valor_desconto"
                />
              </div>
              <div v-if="plano.tipo_desconto == 'abs'" class="form-group">
                <label>Valor Absoluto</label>
                <money  class="form-control" v-model="plano.valor_desconto" v-bind="money"></money> 
              </div>
            </div>   
            <div class="col-md-4">
              <div class="form-group">
                <label>Status do plano</label>
                <select class="form-control" v-model="plano.active">
                  <option :value="1">Ativo</option>
                  <option :value="0">Desativado</option>
                </select>
              </div>
            </div>
            <div class="form-group">
              <label>Descrição Vendas <b>*Obrigatório</b></label>
              <vue-editor v-model="plano.descricao_vendas" :editorToolbar="customToolbar"></vue-editor>
            </div>
            <div class="form-group">
              <label>Cobertura Plano <b>*Obrigatório</b></label>
              <vue-editor v-model="plano.cobertura" :editorToolbar="customToolbar"></vue-editor>
            </div>
            <div class="form-group">
              <label>Dúvidas Frequentes</label>
              <vue-editor v-model="plano.duvidas" :editorToolbar="customToolbar"></vue-editor>
            </div>
            <p>
              <button
                href="#0"
                class="btn_1 medium pull-right"
                @click="atualizaPlano()"
              >Salvar modificações</button>
            </p>
          </div>
        </div>

        <hr />
        <!-- Card de abrangência -->
        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-file"></i>Arquivos
            </h2>
            <p>Adicione ou remova arquivos na lista abaixo</p>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Nome arquivo</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Nome do arquivo"
                  v-model="nomeArquivo"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Arquivo</label>
                <input
                  type="file"
                  class="form-control"
                  id="file"
                  ref="file"
                  @change="handleFileUpload"
                />
              </div>
            </div>
            <div class="col-md-1">
              <button href="#0" class="btn_1 mt-4" @click="addArquivo()">
                <i class="fa fa-plus"></i>
              </button>
            </div>
            <div class="col-md-12">
              <ul>
                <li :key="arquivo.id" v-for="arquivo of arquivos">
                  {{arquivo.nome}}
                  <i class="fa fa-times" @click="rmArquivo(arquivo.id)"></i>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- /container-fluid-->
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import { ajax, tratamento_requisicao, alerta } from "@/utils/util";
import funcoesGerais from "@/assets/js/funcoes.js";
import axios from "axios";
import moment from "moment";
import { VueEditor } from "vue2-editor";
import { Money } from "v-money";
import { ReturnStringErrorByArrayOfErrors } from '../../../utils/util';

export default {
  components: {
    VueEditor,
    Money,
  },
  mixins: [funcoesGerais],
  data() {
    return {
      id_plano: this.$route.params.id_plano,
      flagTrue: 1,
      flagFalse: 0,
      arquivos: [],
      operadoras: [],
      listaPlanos: [],
      nomeArquivo: "",
      file: "",
      foto_plano: "",
      plano: {
        name: "",
        descricao_vendas: "",
        price: "",
        cobertura: "",
        setup_fee: "",
        ans: "",
        length_interval: 1,
        unit_interval: "Monthly",
        active: 0,
        tipo_plano: 0,
        plan_number:'',
        contrato:'',
        TokenAcesso: '',
        recorrencia: '',
        planos_vinculados: [],
      },
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false,
      },
      faixas:[
        {
          active:null,
          carencia:null,
          carencia_boleto:null,
          id:null,
        }],
      imagem_foto: "",
      mostraErro: false,
      isLoading: false,
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
      ],
    };
  },
  watch: {
    "plano.tipo_plano"(newValue) {
      if (newValue === "1") {
        if (!this.faixas || this.faixas.length === 0) {
          this.faixas = [
            {
              active: 0,
              price: "",
              min: "",
              max: "",
            },
          ];
        }
      } else {
        this.faixas = [];
      }
    },
  },
  created() {
    var self = this;
    var user = JSON.parse(localStorage.getItem("token_adm_comprodonto"));
    if (user) {
      self.isLoading = true;

      Promise.all([
        ajax("get", "/planos/detalhes/" + self.id_plano + "/adm"),
        ajax("get", "/operadoras")
      ])
      .then(([planosRes, operadorasRes]) => {
          if (planosRes && planosRes.plano) {
            const planoData = planosRes.plano;
            self.plano = {
              ...planoData,
              active: Number(planoData.active || 0),
              recorrencia: Number(planoData.recorrencia || 0),
              tipo_plano: Number(planoData.tipo_plano || 0),
              price: self.emReais(planoData.price),
              setup_fee: self.emReais(planoData.setup_fee || 0),
              valor_boleto: self.emReais(planoData.valor_boleto || 0)
            };
            if(planoData.planos_vinculados && planoData.planos_vinculados.length > 0){
              planoData.planos_vinculados.forEach(plano => {
                plano.price = self.emReais(plano.price);
                plano.setup_fee = self.emReais(plano.setup_fee || 0);
              });
            }
            
            self.imagem_foto = planoData.foto_plano || '';
            self.arquivos = planosRes.arquivos || [];
            self.faixas = planosRes.faixas || [];
            self.faixas.forEach((faixa, index)=>{
              faixa.price=self.emReais(faixa.price)
              faixa.setup_fee=self.emReais(faixa.setup_fee)
              faixa.valor_boleto=self.emReais(faixa.valor_boleto)
            })
          }
          
          self.operadoras = Array.isArray(operadorasRes) ? operadorasRes : [];
          this.getPlanosFromUniodonto();
          self.isLoading = false;
        })
        .catch((error) => {
          self.isLoading = false;
          tratamento_requisicao(error, this);
        });
    } else {
      self.$router.replace(self.$route.query.redirect || "/");
    }
  },
  methods: {
    addPlanoVinculado() {
      this.plano.planos_vinculados.push({
        plano_familiar_id: this.plano.id,
        plans_id: "",
        price: "",
        setup_fee: "",
        carencia: "",
        carencia_boleto: "",
        qtd_min: ""
      });
    },
    removePlanoVinculado(index) {
      this.plano.planos_vinculados.splice(index, 1);
    },
    getValoresDoPlano(plan) {
      const base = this.listaPlanos.find(p => p.id === plan.plans_id);
      if (base) {
        plan.price = (base.price/100) || "";
        plan.setup_fee = (base.setup_fee/100) || "";
        plan.carencia = base.carencia || "";
        plan.carencia_boleto = base.carencia_boleto || "";
      }
      console.log(plan);
    },
    getPlanosFromUniodonto(){
      console.log(this.plano.provider_id);
        ajax("get", `operadoras/${this.plano.provider_id}/planos/adm`)
        .then((response) => {
          this.isLoading = false;
          this.listaPlanos = response.data;
        })
        .catch((error) => {
          this.isLoading = false;
          tratamento_requisicao(error, this);
        });
    },
    handleClickAddPlan() {
      this.faixas.push({
        active: null,
        carencia: null,
        carencia_boleto: null,
        created_at: null,
        id: null,
        max: null,
        min: null,
        plans_id: this.plano.id,
        price: null,
        setup_fee: null,
      })
      console.log('rararara', this.faixas)
    },
    handleClickRemovePlan(index) {
      this.faixas.splice(index, 1);
    },
    emCentavos(valor) {
      return Math.round(valor * 100);
    },
    emReais(valor) {
      return valor / 100;
    },
    atualizaPlano() {
      const self = this;
      self.isLoading = true;
      
      const planoData = JSON.parse(JSON.stringify(self.plano));

      if(planoData.qtd_membros==0){
        alert('A quantidade de membros deve ser maior que 0!');
        self.isLoading = false;
        return;
      }
      
      if (Number(self.plano.tipo_plano) === 0) {
        // Handle Pessoa Física
        if (planoData.price && planoData.cobertura && planoData.name && planoData.ans && planoData.descricao_vendas) {
          planoData.price = planoData.price > 0 ? self.emCentavos(planoData.price) : null;
          planoData.setup_fee = self.emCentavos(planoData.setup_fee);
          if (planoData.valor_boleto > 0) {
            planoData.valor_boleto = self.emCentavos(planoData.valor_boleto);
          } else {
            planoData.valor_boleto = null;
          }

          const formData = new FormData();
          Object.keys(planoData).forEach(key => {
            if (key !== "planos_vinculados") {
              let valor = planoData[key];
              if (valor === null || valor === undefined) {
                valor = "";
              }
              formData.append(key, valor);
            }
          });
          
          if (self.file) {
            formData.append('foto', self.file);
          }
          if (self.foto_plano) {
            formData.append('foto_plano', self.foto_plano);
          }

          ajax("post", "/planos/" + self.plano.id, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
            .then((response) => {
              self.isLoading = false;
              alerta("success", "Sucesso", "Plano atualizado com sucesso!");
              if (response.plano) {
                self.plano.price = self.emReais(response.plano.price);
                self.plano.setup_fee = self.emReais(response.plano.setup_fee);
                self.plano.valor_boleto = response.plano.valor_boleto ? self.emReais(response.plano.valor_boleto) : null;
                if (response.plano.foto) {
                  self.imagem_foto = response.plano.foto;
                }
              }
            })
            .catch((error) => {
              self.isLoading = false;
              self.erroCadastro = true;
              tratamento_requisicao(error, this);
            });
        } else {
          let erros = {};
          if (!self.plano.name) erros.name = ["O campo nome é obrigatório."];
          if (!self.plano.ans) erros.ans = ["O campo ans é obrigatório."];
          if (!self.plano.descricao_vendas) erros.descricao_vendas = ["O campo descrição vendas é obrigatório."];
          if (!self.plano.price) erros.price = ["O campo preço é obrigatório."];
          if (!self.plano.cobertura) erros.cobertura = ["O campo cobertura é obrigatório."];
          alerta("warning", "Atenção", ReturnStringErrorByArrayOfErrors(erros));
        }
      } else if (Number(self.plano.tipo_plano) === 2) {
        // Handle Plano Familiar
        if(planoData.planos_vinculados && planoData.planos_vinculados.length > 0){
          planoData.planos_vinculados.forEach(plano => {
            plano.price = self.emCentavos(plano.price);
            plano.setup_fee = self.emCentavos(plano.setup_fee || 0);
          });
        }

        let precoTotal = 0;
        let setup_feeTotal = 0;

        planoData.planos_vinculados.forEach(plano => {

          precoTotal += plano.price;
          setup_feeTotal += plano.setup_fee;
        });

        planoData.price = precoTotal;
        planoData.setup_fee = setup_feeTotal;

        const formData = new FormData();
        Object.keys(planoData).forEach(key => {
          if (key !== "planos_vinculados") {
            let valor = planoData[key];
            if (valor === null || valor === undefined) {
              valor = "";
            }
            formData.append(key, valor);
          }
        });

        if (Array.isArray(planoData.planos_vinculados) && planoData.planos_vinculados.length > 0) {
          formData.append('planos_vinculados', JSON.stringify(planoData.planos_vinculados));
        }
        
        if (self.file) {
          formData.append('foto', self.file);
        }
        if (self.foto_plano) {
          formData.append('foto_plano', self.foto_plano);
        }

        ajax("post", "/planos/" + self.plano.id, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
          .then((response) => {
            self.isLoading = false;
            alerta("success", "Sucesso", "Plano atualizado com sucesso!");
            if (response.plano) {
              self.plano.price = self.emReais(response.plano.price);
              self.plano.setup_fee = self.emReais(response.plano.setup_fee);
              self.plano.valor_boleto = response.plano.valor_boleto ? self.emReais(response.plano.valor_boleto) : null;
              if (response.plano.foto) {
                self.imagem_foto = response.plano.foto;
              }
            }
          })
          .catch((error) => {
            self.isLoading = false;
            if (error.response && error.response.data && error.response.data.error) {
              const errorData = error.response.data.error;
              if (typeof errorData === 'object') {
                const errorMessage = Object.values(errorData).join('\n');
                alerta("error", "Erro", errorMessage || "Ocorreu um erro ao atualizar o plano.");
              } else {
                alerta("error", "Erro", errorData || "Ocorreu um erro ao atualizar o plano.");
              }
            } else {
              alerta("error", "Erro", "Não foi possível atualizar o plano. Tente novamente mais tarde.");
            }
          });
      } else if (Number(self.plano.tipo_plano) === 1) {
        // Handle Pessoa Jurídica
        let valido = true;
        let erros = {};

        self.faixas.forEach((item, index) => {
          if (!item.price || !item.min || !item.max) {
            valido = false;
            if (!item.price) {
              if (!erros.price) erros.price = [];
              erros.price.push(`O campo preço na Faixa ${index + 1} é obrigatório.`);
            }
            if (!item.min) {
              if (!erros.min) erros.min = [];
              erros.min.push(`O campo quantidade mínima na Faixa ${index + 1} é obrigatório.`);
            }
            if (!item.max) {
              if (!erros.max) erros.max = [];
              erros.max.push(`O campo quantidade máxima na Faixa ${index + 1} é obrigatório.`);
            }
          }
        });

        if (valido) {
          self.faixas.forEach((item,index)=>{
            item.price = item.price > 0 ? self.emCentavos(item.price) : null;
            item.setup_fee = item.setup_fee > 0 ? self.emCentavos(item.setup_fee) : null;
            if (item.valor_boleto > 0) {
              item.valor_boleto = self.emCentavos(item.valor_boleto);
            } else {
              item.valor_boleto = null;
            }
          })

          var objRequest = new FormData();
          var item = self.plano;
          for (var key in item) {
            objRequest.append(key, item[key]);
          }
          objRequest.append("faixas", JSON.stringify(self.faixas));
          objRequest.append("active", JSON.stringify(1));
          objRequest.append("price", JSON.stringify(1));
          self.isLoading = true;
          ajax("post", "/planos/" + self.plano.id, objRequest)
            .then((response) => {
              self.isLoading = false;
              alerta("success", "Sucesso", "Plano atualizado com sucesso!");
              self.faixas.forEach((faixa, index)=>{
                faixa.price=self.emReais(faixa.price)
                faixa.setup_fee=self.emReais(faixa.setup_fee)
                faixa.valor_boleto=self.emReais(faixa.valor_boleto)
              })
            })
            .catch((error) => {
              self.isLoading = false;
              self.erroCadastro = true;
              tratamento_requisicao(error, this);
            });
        } else {
          alerta("warning", "Atenção", ReturnStringErrorByArrayOfErrors(erros));
        }
      }
    },
    rmArquivo(idArquivo) {
      var self = this;
      self.isLoading = true;
      ajax("delete", "/arquivos/" + idArquivo)
        .then((response) => {
          self.isLoading = false;
          alert("Arquivo removido!");
          let index = self.arquivos.findIndex((x) => x.id == idArquivo);
          self.arquivos.splice(index, 1);
        })
        .catch((error) => {
          self.isLoading = false;
          tratamento_requisicao(error, this);
        });
    },
    addArquivo() {
      var self = this;
      self.isLoading = true;

      let formData = new FormData();
      formData.append("plan_id", self.id_plano);
      formData.append("file", self.file);
      formData.append("nome", self.nomeArquivo);

      ajax("post", "/upload", formData)
        .then((response) => {
          self.isLoading = false;
          alert("Arquivo adicionado!");
          self.file = "";
          self.nomeArquivo = "";
          self.arquivos.push(response);
        })
        .catch((error) => {
          self.isLoading = false;
          tratamento_requisicao(error, this);
        });
    },
    handleFileUpload(e) {
      var files = e.target.files;
      this.file = files[0];
    },
    trocaFoto: function ($event) {
      console.log('Arquivo selecionado:', $event.target.files[0]);
      const file = $event.target.files[0];
      if (!file) return;
      if (!file.type.startsWith('image/')) {
        alert('Por favor, selecione uma imagem válida.');
        return;
      }
      this.foto_plano = file;
      this.imagem_foto = URL.createObjectURL(this.foto_plano);
    },
  },
};
</script>